<main
    class="agpr-influencerStreams agpr-influencerStreams-container"
>
    <h1 class="u-srOnly">{{'Discover.influencerStreams' | localize}}</h1>
    <agpr-scroll-panel>
        <section
            class="agpr-center"
            cdkDropList
            cdkDropListOrientation="horizontal"
            (cdkDropListDropped)="drop($event)"
            [attr.aria-label]="'Common.layout.main' | localize"
        >
            <div #dragUpdate class="u-srOnly" aria-live="polite"></div>
            <span id="drag_description" class="u-srOnly">{{'Discover.influencerStreams.dragDesc' | localize}}</span>
            <div
                *ngFor="let stream of streams; index as i"
                class="agpr-influencerStreams-stream agpr-contextMenu-parent"
                [class.agpr-influencerStreams-stream--editing]="stream.editing"
                [class.first]="i == 0"
                [attr.aria-busy]="stream.loading"
                cdkDrag
                role="group"
                [attr.aria-labelledby]="'influencerStream_' + i + '_headerName_sr'"
            >
                <div [agprLoading]="stream.loading" [style.height]="'100%'">
                    <div
                        class="drag-drop-placeholder"
                        *cdkDragPlaceholder
                    >
                    </div>

                    <div
                        class="agpr-influencerStreams-stream-dragDropper"
                        cdkDragHandle
                        [cdkDragHandleDisabled]="stream.editing"
                        tabindex="0"
                        dropeffect="move"
                        role="button"
                        [attr.grab]="activeStream === i ? 'true' : 'supported'"
                        [attr.aria-label]="'Discover.influencerStreams.dragLabel' | localize"
                        aria-describedby="drag_description"
                        (keydown)="onKeydown($event, i)"
                    >
                        <span aria-hidden="true" class="fa-kit fa-agpr-drag-drop"></span>
                    </div>

                    @if (!stream.editing && !stream.loading) {
                        <ul class="agpr-contextMenu top right">
                            <li>
                                <agpr-button
                                    [style]="buttonTypes.contextMenu"
                                    icon="fa-regular fa-duotone fa-pen"
                                    tooltip="Discover.influencerStreams.configureStream"
                                    [expanded]="false"
                                    (click)="stream.editing = true"
                                ></agpr-button>
                            </li>
                        </ul>
                    }

                    <agpr-influencer-stream
                        #influencerStream
                        [stream]="stream"
                        [index]="i"
                        [streamsLength]="streams.length"
                        (mentionSelected)="streamMentionSelected($event)"
                        (deletedIndex)="streamDeleted($event)"
                        (skipCurrentStream)="skipCurrentStream($event)"
                        (streamLoading)="stream.loading = $event;"
                    ></agpr-influencer-stream>
                </div>
            </div>

            <ng-container *ngFor="let i of [0,1,2,3]">
                <div *ngIf="i >= streams?.length" class="agpr-influencerStreams-stream agpr-influencerStreams-newStreamButton">
                    <div class="agpr-influencerStreams-newStreamButtonWrapper">
                        <agpr-button
                            #addNewStreamButton
                            *ngIf="i === streams?.length"
                            label="Discover.influencerStreams.newStream"

                            [style]="buttonTypes.primary"
                            [wide]="true"
                            [id]="'influencerStream.' + i + '.createButton'"
                            (click)="createStream()"
                        ></agpr-button>
                    </div>
                </div>
            </ng-container>
        </section>
    </agpr-scroll-panel>


    <aside
        class="agpr-sidebar"
        [attr.aria-label]="'Common.layout.rhp' | localize"
    >
        <agpr-rhp-contexts
            #rhpContexts
            [id]="'influencerStream_rhpContexts'"
            [hideOutletContactTabs]="noContentFound"
            [contentCollapseToggle]="true"
            [contentCollapseParams]="{width: '23vw', minWidth: '350px'}"
        >
            <agpr-tab
                [id]="'influencerStream.mentionTab'"
                icon=" fa-file"
                tooltip="Monitoring.results.rhp.mention"
            >
                <agpr-mention-details
                    [id]="'influencerStream.mentionTabDetails'"
                ></agpr-mention-details>
                <agpr-panel
                   *ngIf="noContentFound"
                    header="Mention.details.mention"
                >
                    <agpr-message [severity]="messageSeverities.noContent">
                        <span class="agpr-monitoringResult-noMentionsFound"> {{ 'Discover.influencerStreams.noMentionSelected' | localize }} </span>
                    </agpr-message>
                </agpr-panel>
            </agpr-tab>
            <agpr-entity-list-tab
                [id]="'influencerStreams_targetingRhpTab_viewAllContacts'"
                [entityMode]="entityType.CONTACT"
                [heading]="streamContactsTabHeader"
                [tooltip]="'Discover.influencerStreams.contacts' | localize"
                (showRhpTakeOver)="spawnTakeover($event)"
                [showActionsButton]='false'
            ></agpr-entity-list-tab>
        </agpr-rhp-contexts>
    </aside>
</main>
